/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nopastevents2Inputs */

const en_nopastevents2 = /** @type {(inputs: Nopastevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No past events`)
};

const de_nopastevents2 = /** @type {(inputs: Nopastevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine vergangenen Events`)
};

/**
* | output |
* | --- |
* | "No past events" |
*
* @param {Nopastevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nopastevents2 = /** @type {((inputs?: Nopastevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nopastevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nopastevents2(inputs)
	return de_nopastevents2(inputs)
});
export { nopastevents2 as "noPastEvents" }